import React from "react";
import { Grid, TextField } from "@material-ui/core";

type columnCount = boolean | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;

interface IGridTextFieldProps {
  label: string;
  xs?: columnCount;
  sm?: columnCount;
  md?: columnCount;
  lg?: columnCount;
  xl?: columnCount;
  onChange?: (value: number) => void;
  value?: number;
  readOnly?: any;
  required?: boolean;
  error?: boolean;
  min?: number;
  max?: number;
}

const GridNumberField = (props: IGridTextFieldProps) => {
  const { label, onChange, value, xs, sm, md, lg, xl, required, readOnly, error, min, max } = props;

  const [innerValue, setInnerValue] = React.useState(value === undefined ? "" : value.toString());

  const minError = value !== undefined && min !== undefined && value < min;
  const maxError = value !== undefined && max !== undefined && value > max;
  const hasError = error || minError || maxError;

  const innerOnChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const parsed = parseInt(event.target.value);
    if (!Object.is(NaN, parsed) && onChange) {
      setInnerValue(parsed.toString());
      onChange(parsed);
    } else {
      setInnerValue(event.target.value);
      if (onChange) {
        onChange(0);
      }
    }
  };

  return (
    <Grid item={true} xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      <TextField
        type="number"
        label={label}
        fullWidth={true}
        onChange={innerOnChange}
        value={innerValue}
        InputProps={{
          inputProps: { min, max },
          readOnly: readOnly,
        }}
        required={required}
        error={hasError}
      />
    </Grid>
  );
};

export default GridNumberField;
